Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "About1794701709",
  {"description":"About1794701709--description","header":"About1794701709--header","readMore":"About1794701709--readMore","root":"About1794701709--root"},
  "",
  13,
  "About1794701709"
);

